import { apiClient } from 'shared/api-client';

import { createMutationFn } from './utils';

// Do not use this approach, create custom hooks instead

export const applyConsents = createMutationFn({
  fn: (consents: string[]) =>
    apiClient.patch('bi/consent-clusters/apply_consents/', {
      json: {
        slugs: consents,
      },
    }),
  invalidates: [['consents']],
});
